import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import GoogleAnalytics from "./components/GoogleAnalytics";
import SchemaMarkup from "./components/SchemaMarkup";
import Home from "./pages/Home";
import About from "./pages/About";
import SoftwareAIServices from "./pages/SoftwareAIServices";
import ERPAMCSolutions from "./pages/ERPAMCSolutions";
import CyberSecurityServices from "./pages/CyberSecurityServices";
import IoTSmartCity from "./pages/IoTSmartCity";
import CCTVSurveillance from "./pages/CCTVSurveillance";
import OutsourceSupport from "./pages/OutsourceSupport";
import ManpowerServices from "./pages/ManpowerServices";
import TrainingPlacement from "./pages/TrainingPlacement";
import Certifications from "./pages/Certifications";
import Industries from "./pages/Industries";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <GoogleAnalytics />
          <SchemaMarkup />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/software-ai-services" element={<SoftwareAIServices />} />
            <Route path="/erp-amc-solutions" element={<ERPAMCSolutions />} />
            <Route path="/iot-smart-city" element={<IoTSmartCity />} />
            <Route path="/cybersecurity-services" element={<CyberSecurityServices />} />
            <Route path="/cctv-surveillance" element={<CCTVSurveillance />} />
            <Route path="/outsource-support" element={<OutsourceSupport />} />
            <Route path="/manpower-services" element={<ManpowerServices />} />
            <Route path="/training-placement" element={<TrainingPlacement />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
